module.exports = __webpack_public_path__ + "static/img/6303_phase_function_Paper_PointsHejduk_Prediction.1c17fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6303_phase_function_Paper_PointsHejduk_Prediction.png
// module id = td3s
// module chunks = 0